import type { Service } from "@/types/Service";
import formConfigFixture from "@/fixtures/formConfig.json";
import type { FormConfig } from "@/types/FormConfig";

export const previewService: Service = {
  name: "preview",
  getFormConfig: async () => {
    if (window.__FORM_CONFIG__) {
      return {
        ...window.__FORM_CONFIG__,
        active: true,
      } as FormConfig;
    }

    return formConfigFixture as unknown as FormConfig;
  },
  checkActiveRecurring: async () => {
    return { active: false };
  },
  validateBankDetails: async () => {
    return true;
  },
  verifyEmail: async () => {
    return {
      status: "valid",
      suggestion: null,
      isDisposable: false,
      isFraudRisk: false,
    };
  },
  verifyAddress: async () => {
    return { status: "verified", avc: "", suggestion: null };
  },
  getRetrieveAvailableDates: async () => {
    return {
      "available-dates": ["2025-05-15", "2025-05-28", "2025-06-01"],
    };
  },
  sendGiftAid: async () => {},
  sendSignUpFrontline: async () => {},
};
